module.exports = __webpack_public_path__ + "media/images/emblems/Unterseen-coat_of_arms-38b55fea1aa534955ffc94d02a1e866b.svg";